module.exports = __webpack_public_path__ + "img/odd-slice.8b5a6cff.svg";